import React from "react";
import withStyles from '@mui/styles/withStyles';
const styles = (theme) => ({});

const expiresAt = ({ date }) => {
  const withoutTime = { year: "2-digit", month: "2-digit", day: "2-digit" };
  return <>Gültig Bis: {new Date(date.split(' ')[0].replace(/-/g, "/")).toLocaleDateString("de", withoutTime)}</>;
};
export default withStyles(styles)(expiresAt);
